module.exports = function drawTickled(ctx) {
  ctx.save();
  ctx.strokeStyle = 'rgba(0,0,0,0)';
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.fillStyle = '#ffdf40';
  ctx.beginPath();
  ctx.arc(8.68066, 8, 8, 0, 6.283185307179586, true);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#66342d';
  ctx.strokeStyle = '#66342d';
  ctx.lineWidth = 0.3806400001049042;
  ctx.globalAlpha = 1;
  ctx.beginPath();
  ctx.moveTo(13.5345, 10.2406);
  ctx.bezierCurveTo(13.5798, 10.2276, 13.6214, 10.2153, 13.6592, 10.2039);
  ctx.bezierCurveTo(13.5753, 11.2596, 12.9965, 12.2704, 12.1333, 13.0403);
  ctx.bezierCurveTo(11.1989, 13.8737, 9.94779, 14.4091, 8.68, 14.4091);
  ctx.bezierCurveTo(7.41221, 14.4091, 6.16115, 13.8737, 5.22673, 13.0403);
  ctx.bezierCurveTo(4.36354, 12.2704, 3.7847, 11.2596, 3.70085, 10.2039);
  ctx.bezierCurveTo(3.73858, 10.2153, 3.78016, 10.2276, 3.8255, 10.2406);
  ctx.bezierCurveTo(4.0758, 10.3129, 4.44059, 10.4087, 4.90166, 10.5045);
  ctx.bezierCurveTo(5.82356, 10.6959, 7.13171, 10.8871, 8.68, 10.8871);
  ctx.bezierCurveTo(10.2283, 10.8871, 11.5364, 10.6959, 12.4583, 10.5045);
  ctx.bezierCurveTo(12.9194, 10.4087, 13.2842, 10.3129, 13.5345, 10.2406);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#f5f6e8';
  ctx.globalAlpha = 1;
  ctx.beginPath();
  ctx.moveTo(13.0164, 11.5358);
  ctx.bezierCurveTo(13.1825, 11.2168, 13.3021, 10.8837, 13.3681, 10.5447);
  ctx.bezierCurveTo(13.1382, 10.6062, 12.8509, 10.6765, 12.5129, 10.7467);
  ctx.bezierCurveTo(11.5779, 10.9408, 10.2528, 11.1344, 8.68451, 11.1344);
  ctx.bezierCurveTo(7.11626, 11.1344, 5.79107, 10.9408, 4.85607, 10.7467);
  ctx.bezierCurveTo(4.51815, 10.6765, 4.23079, 10.6062, 4.00089, 10.5447);
  ctx.bezierCurveTo(4.06689, 10.8837, 4.18657, 11.2168, 4.35258, 11.5358);
  ctx.bezierCurveTo(5.13498, 11.9782, 6.6021, 12.5976, 8.68451, 12.5976);
  ctx.bezierCurveTo(10.7669, 12.5976, 12.234, 11.9782, 13.0164, 11.5358);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#66342d';
  ctx.beginPath();
  ctx.moveTo(3.97139, 4.76087);
  ctx.bezierCurveTo(4.0922, 4.51256, 4.39143, 4.40919, 4.63975, 4.52999);
  ctx.lineTo(7.59975, 5.96999);
  ctx.bezierCurveTo(7.77181, 6.0537, 7.88101, 6.22826, 7.88101, 6.41961);
  ctx.bezierCurveTo(7.88101, 6.61095, 7.77181, 6.78552, 7.59975, 6.86922);
  ctx.lineTo(4.63975, 8.30922);
  ctx.bezierCurveTo(4.39143, 8.43003, 4.0922, 8.32666, 3.97139, 8.07834);
  ctx.bezierCurveTo(3.85059, 7.83002, 3.95396, 7.53079, 4.20228, 7.40999);
  ctx.lineTo(6.23807, 6.41961);
  ctx.lineTo(4.20228, 5.42922);
  ctx.bezierCurveTo(3.95396, 5.30842, 3.85059, 5.00919, 3.97139, 4.76087);
  ctx.closePath();
  ctx.moveTo(13.3906, 4.76087);
  ctx.bezierCurveTo(13.5114, 5.00919, 13.4081, 5.30842, 13.1597, 5.42922);
  ctx.lineTo(11.124, 6.41961);
  ctx.lineTo(13.1597, 7.40999);
  ctx.bezierCurveTo(13.4081, 7.53079, 13.5114, 7.83002, 13.3906, 8.07834);
  ctx.bezierCurveTo(13.2698, 8.32666, 12.9706, 8.43003, 12.7223, 8.30922);
  ctx.lineTo(9.76228, 6.86922);
  ctx.bezierCurveTo(9.59022, 6.78552, 9.48101, 6.61095, 9.48101, 6.41961);
  ctx.bezierCurveTo(9.48101, 6.22826, 9.59022, 6.05369, 9.76228, 5.96999);
  ctx.lineTo(12.7223, 4.52999);
  ctx.bezierCurveTo(12.9706, 4.40919, 13.2698, 4.51256, 13.3906, 4.76087);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
};
